<template>
  <v-clamp
    :class="[
      'asc-required-label',
      required ? 'is__required' : null,
      uppercase ? 'text-uppercase' : null,
    ]"
    autoresize
    :max-lines="1"
  >
    {{ label }}
    <template v-if="required" #after>
      <slot name="beforeRequired"></slot>
      <span class="required">required</span>
    </template>
  </v-clamp>
</template>

<script>
import VClamp from 'vue-clamp'
export default {
  name: 'AscRequiredLabel',

  components: {
    VClamp,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-required-label {
  .required {
    background-color: $gray-100;
    padding: 1px 4px;
    color: $gray-700;
    font-size: 10px;
    letter-spacing: 0;
    line-height: 12px;
    text-align: center;
    border-radius: 1px;
    vertical-align: middle;
    margin-left: 6px;
    text-transform: lowercase !important;
  }
}

.v-label--active {
  .required {
    font-size: 10px;
  }
}

.is__required .v-label {
  max-width: 100%;
  overflow: auto;
  white-space: normal;
}
</style>
